import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const editSchoolStaff = (schoolStaffId, schoolStaffData) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_STAFF_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/schoolStaff/edit/' + schoolStaffId, schoolStaffData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SCHOOL_STAFF_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_STAFF_NOT_LOADING'
        })
    }
}

export const addSchoolStaff = (schoolStaffData) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_STAFF_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/client/schoolStaff/register', schoolStaffData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SCHOOL_STAFF_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_STAFF_NOT_LOADING'
        })
    }
}

export const getSchoolStaffsBySchool = (school) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_STAFF_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/schoolStaff/getBySchool/' + school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SCHOOL_STAFF_GET_ALL_SUCCESS',
                payload: data.schoolStaffs
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_STAFF_NOT_LOADING'
        })
    }
}

export const getSchoolStaffsByMultiSchool = (school) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_STAFF_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/schoolStaff/getByMultiSchool/' + school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SCHOOL_STAFF_GET_ALL_SUCCESS',
                payload: data.schoolStaffs
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_STAFF_NOT_LOADING'
        })
    }
}

export const deleteSchoolStaff = (schoolStaffId) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_STAFF_LOADING'
    })
    try {
        const { data, status } = await Axios.delete('/api/client/schoolStaff/remove/' + schoolStaffId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SCHOOL_STAFF_REMOVE_SUCCESS',
                payload: {message: data.message, schoolStaff: schoolStaffId}
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_STAFF_NOT_LOADING'
        })
    }
}